import type { OrderbookStore, OrderbookEvent } from '../types';

/**
 * Global renderer state store
 * Contains all orderbook state, render tracking, and UI state
 */
export const store: OrderbookStore = {
  books: new Map(),
  renderScheduled: false,
  currentAssetIds: [],
  currentSlug: '',
  latestConditionId: undefined,
  positionsByAssetId: new Map(),
  currentSide: 'BUY',
  // Set of keys "assetId|SIDE|price.xx" to highlight open orders in the book
  openOrdersIndex: new Set(),
  orderIndex: new Map(),
  // Per-asset price decimals (derived from tick size). Defaults to 2
  priceDecimalsById: {},
  // Orderbook status tracking
  obLastHeartbeatTs: 0,
  obLastBookTs: 0, // When orderbook message received
  obLastRenderTs: 0, // When last successful render completed
  obLastMessageTs: 0, // When last message was received (before processing)
  obLastApplyErrorTs: 0,
  obLastTradeLikeTs: 0,
  obLastRenderError: null,
  obState: 'idle',
  // Render diagnostics
  renderAttempts: 0,
  renderFailures: 0,
  renderSuccesses: 0,
  activeRender: false, // Prevent overlapping renders
  pendingEvents: [] as OrderbookEvent[], // Queue events during active render
};


